import { StandardResponseModel } from "../pages/shared/models/standard-response-model";
import { StoreModel } from "../redux/reducers/static-data.reducers";
import { RecipientUpdateMeta } from "./recipient.service";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function getProductStores(
  filter?: Record<string, any>,
  limit?: number,
  page?: number,
): Promise<StandardResponseModel<StoreModel>> {

  try {
    const authorizationHeader = configAuthorizationHeader();
    const params = new URLSearchParams();

    params.append("limit", "" + (limit || '100'));
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(`${API_URL}/stores`, { filter }, { params, ...authorizationHeader })
      .then((response) => {
        return response?.data as StandardResponseModel<StoreModel>;
      });
  } catch (error) {
    console.error(error);
    return Promise.reject();
  }
}

async function editProductStore(storeId: number, updateData: StoreModel) {
  try {
    const authorizationHeader = configAuthorizationHeader();

    return axiosInstance
      .put(
        `${API_URL}/store/${storeId}`,
        {
          ...updateData,
          storeId: undefined,
        },
        authorizationHeader,
      )
      .then((response) => response?.data as RecipientUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function deleteStoreById(storeId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.delete(
      `${API_URL}/store/${storeId}`,
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  getProductStores,
  editProductStore,
  deleteStoreById,
};
